import React from 'react';

import './ProfileDetailsBadge.css';
import { cn } from '@wwe-portal/ui/lib/lib';

function ProfileDetailsBadge({
  bgImg,
  data,
  title,
  className,
}: {
  bgImg: string;
  data: string | number;
  title: string;
  className?: string;
}) {
  return (
    <div
      className={cn('profile-details-badge relative', className)}
      style={{
        backgroundImage: `url(${bgImg})`,
      }}
    >
      <div className="profile-details-badge-text">
        <p className="text-inlineTextColor8 mb-0 pb-0 text-center text-sm font-semibold">
          {data}
        </p>
        <p className="text-inlineTextColor10 mb-0 text-center text-xs">
          {title}
        </p>
      </div>
    </div>
  );
}

export default ProfileDetailsBadge;
